import { Component, Input } from '@angular/core';

@Component({
    selector: 'cmps-scorecard-category',
    template: `
        <div class="cmps-scorecard-category--container">
            <div class="cmps-scorecard-category--label-container">
                <h4 class="cmps-scorecard-category--label">
                    {{ categoryLabel }}
                </h4>
            </div>
            <div class="cmps-scorecard-category--class">
                <div
                    [style.border-color]="categoryColor"
                    class="cmps-scorecard-category--category-value"
                >
                    <span
                        class="cmps-scorecard-category--category-value-label"
                        >{{ categoryValueLabel }}</span
                    >
                    <span
                        [style.background-color]="categoryColor"
                        class="cmps-scorecard-category--category-value-bar"
                    ></span>
                </div>
            </div>
        </div>
    `,
    host: {
        class: 'cmps-scorecard-category',
    },
})
export class CmpsScorecardCategoryComponent {
    @Input() categoryColor: string;
    @Input() categoryLabel: string;
    @Input() categoryValueLabel: string;
}
